import * as React from "react";
import { DashboardPageMap } from "./DashboardPageMap.tsx";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { DashboardPageBar } from "./DashboardPageBar.tsx";
import { DashboardDensityMap } from "./DashboardDensityMap.tsx";

export function DashboardPage(): JSX.Element {
    return (
        <div >
            <DashboardPageTabs />
        </div >
    );
}

function DashboardPageTabs(): JSX.Element {
    const [value, setValue] = React.useState<number>(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab sx={{ fontSize: '0.8em' }} label={"Reference Map"} {...a11yProps(0)} />
                    <Tab sx={{ fontSize: '0.8em' }} label={"Bar Charts"} {...a11yProps(1)} />
                    <Tab sx={{ fontSize: '0.8em' }} label={"Density Map"} {...a11yProps(2)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <DashboardPageMap />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <DashboardPageBar />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={2}>
                <DashboardDensityMap />
            </CustomTabPanel>
        </div>
    );
}

interface CustomTabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: CustomTabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
